import { render, staticRenderFns } from "./InvoicesDataViewMobile.vue?vue&type=template&id=c8af3ea6&scoped=true&"
import script from "./InvoicesDataViewMobile.vue?vue&type=script&lang=js&"
export * from "./InvoicesDataViewMobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8af3ea6",
  null
  
)

export default component.exports